type BrowserCrypto = Crypto & {
  randomUUID?: () => string;
};

const getBrowserCrypto = (): BrowserCrypto | undefined => {
  if (typeof globalThis === 'undefined') return undefined;
  return globalThis.crypto as BrowserCrypto | undefined;
};

const createUuidFromRandomValues = (cryptoRef: BrowserCrypto): string | null => {
  if (typeof cryptoRef.getRandomValues !== 'function') return null;

  const bytes = new Uint8Array(16);
  cryptoRef.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
};

export const createRandomId = (): string => {
  const cryptoRef = getBrowserCrypto();
  if (typeof cryptoRef?.randomUUID === 'function') {
    return cryptoRef.randomUUID();
  }

  const cryptoId = cryptoRef ? createUuidFromRandomValues(cryptoRef) : null;
  if (cryptoId) return cryptoId;

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`;
};

export const createShortRandomId = (length = 12): string =>
  createRandomId().replace(/-/g, '').slice(0, length);

export const createLocalUploadRefKey = (): string => `upload://local/${createRandomId()}`;
